<!--
 * @Description: 护栏碰撞预警系统
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 14:52:22
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-31 14:34:07
 -->
<template>
  <div class="guardrailCollision">
    <div class="left">
      <Left />
    </div>
    <div class="center">
      <Center />
    </div>
    <div class="right">
      <Right />
    </div>
  </div>
</template>

<script>
import Left from './components/left'
import Center from './components/center'
import Right from './components/right'
export default {
  name: 'guardrailCollision',
  components: {
    Left,
    Center,
    Right,
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .guardrailCollision {
    width: 90%;
    height: calc(100% - 10vh);
    margin: 0 5%;
    padding: 5vh 0;
    display: flex;
    justify-content: space-between;
    .left {
      width: 26%;
      height: 100%;
    }
    .center {
      width: 44%;
      height: 100%;
    }
    .right {
      width: 26%;
      height: 100%;
    }
  }
</style>
